<template>
    <b-modal id="RecetasModificadores" v-model="display" :title="cTitle" size="lg" no-close-on-backdrop no-close-on-esc
        @ok="handleOk" :hide-footer="isLoading">

        <ui-spinner v-if="isLoading"></ui-spinner>

        <template v-else>
            <!-- <b-card no-body :header="fetched.encabezado.nombre"> -->
            <!-- md5 {{ workingValueStamp }} -->
            <b-list-group>

                <b-list-group-item class="text-right">
                    <b-button variant="primary" @click="addEntry">
                        <!-- <span>Agregar</span> &nbsp; -->
                        <i class="fa fa-plus fa-fw"></i>
                    </b-button>
                </b-list-group-item>

                <b-list-group-item v-for="ing in fetched.ingredientes"
                    :key="'i-' + ing.ingrediente_id_pk + '-' + workingValueStamp">
                    <b-row align-content="around" align-v="center">
                        <b-col auto>
                            <div v-if="isIngredientSubstituted(ing.ingrediente_id_pk)">
                                <strong class="text-primary"> {{
                                    makeTitle(getIngredienteSustitutivo(ing.ingrediente_id_pk)) }} <small>[{{
                                        getReplacementObj(ing.ingrediente_id_pk).alcance }}]</small> </strong>
                                <br>
                                <small class="text-danger"> {{ makeTitle(ing) }} </small>
                            </div>
                            <div v-else-if="isIngredientRemoved(ing.ingrediente_id_pk)">
                                <strong class="text-dimmed stroked"> {{
                                    makeTitle((ing)) }}
                                </strong>
                            </div>
                            <div v-else>
                                <strong> {{ makeTitle(ing) }} </strong>
                            </div>
                        </b-col>
                        <b-col auto class="text-right">
                            <b-button-group v-if="!isIngredientRemoved(ing.ingrediente_id_pk)">
                                <b-button variant="danger" @click="askAndRemove(ing)">
                                    <i class="fa fa-times"></i>
                                </b-button>
                                <b-button variant="primary" @click="ajustarIngrediente(ing)">
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                            </b-button-group>
                            <b-button-group v-else>
                                <b-button variant="warning" @click="recuperarIngrediente(ing)">
                                    <i class="fa fa-history"></i> <!-- counter-clockwise arrow -->
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <!-- [{{ isIngredientSubstituted(ing.ingrediente_id_pk) }}][{{ ing }}] -->
                    <!-- <b-badge variant="primary" v-if="isIngredientSubstituted(ing.ingrediente_id_pk)" pill><i class="fa fa-cog"></i></b-badge> -->
                </b-list-group-item>

                <!-- Al final agregar los elementos de workingValue4Adding que tienen el metodo == "Adicion" -->
                <b-list-group-item v-for="ing in workingValue4Adding" :key="'wv-' + ing.ingrediente_id_pk_sustitucion">
                    <b-row align-content="around" align-v="center">
                        <b-col auto>
                            <strong class="text-primary"> 
                                {{ muestraIngrediente(ing.ingrediente_id_pk_sustitucion, ing.cantidad, ing.unidadmedicion_id_pk) }}
                            </strong>
                            <!-- <small class="">Agregado</small> -->
                            <b-badge variant="primary" pill><i class="fa fa-plus"></i> Agregado</b-badge>
                        </b-col>
                        <b-col auto class="text-right">
                            <b-button-group>
                                <b-button variant="danger" @click="askAndRemoveExtra(ing)">
                                    <i class="fa fa-times"></i>
                                </b-button>
                                <b-button variant="primary" @click="ajustarIngredienteExtra(ing)">
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </b-list-group>
            <!-- </b-card> -->
        </template>

        <b-modal v-model="displayAdjust" @hidden="cleanBForm" :title="makeTitle(workingIng)" no-close-on-backdrop
            no-close-on-esc>

            <!-- ALTER TABLE `encabezado_modificadores` -->
            <!-- ADD `metodo` enum('Sustitucion','Omision','Adicion') COLLATE 'utf8mb3_unicode_ci' NOT NULL DEFAULT 'Sustitucion'; -->
            <b-form-row>
                <b-col>
                    <b-form-group id="formMetodo" label="Método">
                        <b-form-select v-model="bForm.metodo" :options="metodoOptions" disabled />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="Alcance">
                        <!-- bForm.alcance debe ser siempre 'Plan' si el metodo == 'Adicion' -->
                        <b-form-select v-model="bForm.alcance" :options="['Plan', 'Receta']" default="Receta" required
                            :disabled="bForm.metodo == 'Adicion'" />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <hr />

            <b-form-group id="formGruposNutrcionalesId" label="Orígen de búsqueda">
                <b-form-select v-model="bForm.gruposNutrcionalesId" :options="gruposNutrcionalesOptions" />
            </b-form-group>

            <b-form-group label="Sustitución">
                <b-form-select v-model="bForm.ingrediente_id_pk_sustitucion" :options="ingredientesOptions" required />
            </b-form-group>

            <b-form-row>
                <b-col>
                    <b-form-group label="Cantidad">
                        <b-form-input v-model="bForm.cantidad" type="number" min="0" required />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="Unidad de medición">
                        <b-form-select v-model="bForm.unidadmedicion_id_pk" :options="unidadesDeMedicionOptions"
                            required />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <hr>

            <b-form-group label="Observaciones">
                <b-form-textarea v-model="bForm.observaciones" />
            </b-form-group>

            <template v-slot:modal-footer="{ cancel }">

                <b-button size="sm" @click="cancel">
                    Cancelar
                </b-button>

                <b-button-group size="sm">
                    <b-button variant="danger" @click="clearWorkingIng" v-if="bForm.ingrediente_id_pk_sustitucion">
                        Según receta
                    </b-button>

                    <b-button variant="primary" @click="applyBForm()">
                        Aceptar
                    </b-button>
                </b-button-group>

            </template>

            <div v-if="debug" class="debug">
                <h1>workingValue</h1>
                <pre><code>{{ workingValue }}</code></pre>
                <hr>
                <h1>bForm</h1>
                <pre><code>{{ bForm }}</code></pre>
                <hr>
                <h1>workingIng</h1>
                <pre><code>{{ workingIng }}</code></pre>
            </div>

        </b-modal>

        <div v-if="debug" class="debug">
            <h1>workingValue</h1>
            <pre><code>{{ workingValue }}</code></pre>
        </div>

    </b-modal>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import { extractForm, confirmFirst, notify } from '@/utils.js'
import md5 from 'js-md5';

const emptyFetched = {
    encabezado: null,
    ingredientes: [],
    unidadesDeMedicion: [],
    mods: [],
},
    bFormArchetype = () => {
        return [
            {
                key: 'id',
                type: 'hidden'
            },
            {
                key: 'gruposNutrcionalesId',
                type: 'hidden'
            },
            {
                key: 'encabezado_id_pk',
                type: 'hidden'
            },
            {
                key: 'ingrediente_id_pk_original',
                type: 'select'
            },
            {
                key: 'ingrediente_id_pk_sustitucion',
                type: 'select'
            },
            {
                key: 'alcance',
                type: 'select',
                options: ['Plan', 'Receta'],
                default: 'Plan'
            },
            {
                key: 'metodo',
                type: 'select',
                default: 'Sustitucion'
            },
            {
                key: 'cantidad',
                type: 'number',
                label: 'Cantidad'
            },
            {
                key: 'plan_id_pk',
                type: 'hidden'
            },
            {
                key: 'unidadmedicion_id_pk',
                type: 'hidden'
            },
            {
                key: 'observaciones',
                type: 'textarea',
                label: 'Observaciones'
            }
        ]
    },
    emptyWorkingIng = {
        ingrediente: '',
        cantidad: 0,
        unidad: ''
    };

export default {

    name: 'RecetasModificadores',

    props: {

        debug: {
            type: Boolean,
            default: true
        },

        requesURI: {
            type: String,
            default: 'recetas/ingredientesymodificadores/'
        },

        value: {
            type: [Array, Object],
            default: () => { return [] }
        },

        planesId: {
            type: [String, Number]
        },

        title: {
            type: String,
            default: 'Configuración de modificadores'
        },

        metodoOptions: {
            type: Array,
            default: () => {
                return [
                    { value: 'Sustitucion', text: 'Sustitución' },
                    { value: 'Omision', text: 'Omisión' },
                    { value: 'Adicion', text: 'Adición' },
                ]
            }
        }
    },

    data: () => {
        return {
            isLoading: false,
            recetasId: false,
            display: false,
            displayAdjust: false,
            fetched: _.clone(emptyFetched),
            workingValue: [],
            bForm: extractForm(bFormArchetype()),
            workingIng: _.clone(emptyWorkingIng),
            asides: {
                gruposnutricionales: [],
                ingredientes: []
            }
        }
    },

    computed: {

        workingValue4Adding() {
            return _.filter(this.workingValue, { metodo: 'Adicion', encabezado_id_pk: this.recetasId });
        },

        workingValueStamp() {
            return md5(JSON.stringify(this.workingValue))
        },

        unidadesDeMedicionOptions() {
            return _.sortBy(_.map(this.fetched.unidadesDeMedicion, udm => {
                return {
                    value: udm.id_pk,
                    text: udm.nombre.toUpperCase().trim()
                }
            }), 'text')
        },

        ingredientesOptions() {

            let opciones = [];

            _.forEach(_.filter(this.asides.gruposnutricionales, { id: this.bForm.gruposNutrcionalesId }), opt => {
                opciones.push(opt.ingrediente_id_pk)
            })

            let filteredData = _.map(_.filter(this.asides.ingredientes, ing => {
                return (opciones.indexOf(ing.id_pk) != -1 || _.isNil(this.bForm.gruposNutrcionalesId))
            }),
                filteredItem => {
                    filteredItem.text = filteredItem.ingrediente.toUpperCase().trim();
                    filteredItem.value = filteredItem.id_pk;
                    return filteredItem;
                }
            );
            return filteredData;
        },

        gruposNutrcionalesOptions() {
            let r = [];
            _.forEach(this.asides.gruposnutricionales, item => {
                r.push({ text: item.alimento, value: item.id })
            })
            return _.concat(_.sortBy(_.uniqBy(r, 'value'), 'text'), [{ text: 'Otro', value: null }]);

        },

        cTitle() {
            return (_.isNil(this.fetched.encabezado)) ? this.title : ('Modificadores para ' + this.fetched.encabezado.nombre).toUpperCase()
        }

    },

    methods: {
        muestraIngrediente(ingrediente_id_pk, cantidad, unidadmedicion_id_pk) {
            try {
                const ingredienteName = (_.find(this.ingredientesOptions, { id_pk: ingrediente_id_pk }).ingrediente.toUpperCase().trim());
                const unidadName = (_.find(this.unidadesDeMedicionOptions, { value: unidadmedicion_id_pk }).text.toUpperCase().trim());
                return ingredienteName + ', ' + parseFloat(cantidad).toFixed(2) + ' ' + unidadName;
            } catch (e) {
                console.error('muestraIngrediente', ingrediente_id_pk, cantidad, unidadmedicion_id_pk)
            }
            return ingrediente_id_pk + ', ' + cantidad + ' ' + unidadmedicion_id_pk;
        },
        async askAndRemoveExtra(ing) {
            try {
                if (await confirmFirst({ title: '¿Seguro que deseas eliminar éste agregado?' })) {
                    // busca el producto en workingValue y lo elimina
                    this.workingValue.splice(this.workingValue.findIndex(item => (
                        item.ingrediente_id_pk_sustitucion === ing.ingrediente_id_pk_sustitucion
                    )), 1);
                }
            } catch (e) {
                notify(e)
            }
        },
        async askAndRemove(ing) {
            try {
                if (await confirmFirst({ title: '¿Seguro que deseas eliminar ésta entrada?' })) {
                    this._prepareIngWorkingIngAndBForm(ing)
                    this.bForm.metodo = 'Omision'
                    this.applyBForm()
                }
            } catch (e) {
                notify(e)
            }
        },
        recuperarIngrediente(ing) {
            this._prepareIngWorkingIngAndBForm(ing)
            this.bForm.ingrediente_id_pk_sustitucion = _.clone(this.bForm.ingrediente_id_pk_original)
            this.bForm.metodo = 'Sustitucion'
            this.clearWorkingIng()
            this.applyBForm()
        },

        _prepareIngWorkingIngAndBForm(ing) {
            this.workingIng = _.clone(ing);
            this.bForm.encabezado_id_pk = _.clone(this.recetasId)
            this.bForm.ingrediente_id_pk_original = _.clone(ing.ingrediente_id_pk)
            if (this.isIngredientEdited(ing.ingrediente_id_pk)) {
                this.bForm = _.merge(this.bForm, _.clone(this.workingValue[this.getIngIndexInWorkingValue(ing.ingrediente_id_pk)]))
            } else {
                this.bForm.ingrediente_id_pk_sustitucion = _.clone(ing.ingrediente_id_pk)
                this.bForm.cantidad = _.clone(ing.cantidad)
                this.bForm.unidadmedicion_id_pk = _.clone(ing.unidadmedicion_id_fk_receta)
                this.bForm.observaciones = _.clone(ing.observaciones)
            }
        },

        handleOk() {
            this.$emit('input', this.workingValue);
        },

        getReplacementObj(ingIdPk) {
            try {
                return _.find(this.workingValue, { ingrediente_id_pk_original: ingIdPk });
            } catch (e) {
                console.error('getReplacementObj', ingIdPk)
            }
        },

        getIngredienteSustitutivo(ingIdPk) {
            try {
                let ingWV = this.getReplacementObj(ingIdPk),
                    ing = _.find(this.asides.ingredientes, { id_pk: ingWV.ingrediente_id_pk_sustitucion });

                // VISUALIZATION ADJUSTMENTS
                ing.cantidad = ingWV.cantidad
                ing.unidad = _.find(this.fetched.unidadesDeMedicion, { id_pk: ingWV.unidadmedicion_id_pk }).nombre

                // RETURNING
                return ing
            } catch (e) {
                console.error('getIngredienteSustitutivo', ingIdPk)
            }
        },

        cleanBForm() {
            this.bForm = extractForm(bFormArchetype());
        },

        isIngredientEdited(ingIdPk) {
            return (this.isIngredientSubstituted(ingIdPk) || this.isIngredientRemoved(ingIdPk))
        },

        insertInWorkingValueBForm() {
            // En el caso de que ya exista el this.bForm.ingrediente_id_pk_sustitucion en el workingValue, si es así, se actualiza
            let found = this.workingValue.some(item => (item.ingrediente_id_pk_sustitucion === this.bForm.ingrediente_id_pk_sustitucion));
            if (found) {
                let index = this.workingValue.findIndex(item => (item.ingrediente_id_pk_sustitucion === this.bForm.ingrediente_id_pk_sustitucion));
                this.workingValue.splice(index, 1);
            }
            this.$nextTick(() => { this.workingValue.push(_.clone(this.bForm)) });
        },

        applyBForm() {
            console.log('applyBForm', this.bForm)

            switch (this.bForm.metodo) {
                case 'Adicion':
                    this.insertInWorkingValueBForm();
                    break;
                default:
                    // Limpia para evitar duplicados
                    if (this.isIngredientEdited(this.bForm.ingrediente_id_pk_original))
                        this.workingValue.splice(this.getIngIndexInWorkingValue(this.bForm.ingrediente_id_pk_original), 1);

                    // Agrega si hay sustitución
                    if (this.bForm.ingrediente_id_pk_sustitucion)
                        this.$nextTick(() => { this.workingValue.push(_.clone(this.bForm)) });
                    break;
            }

            // cierre de modal
            this.displayAdjust = false;
        },

        clearWorkingIng() {
            let cleanBForm = extractForm(bFormArchetype());
            cleanBForm.ingrediente_id_pk_original = _.cloneDeep(this.bForm.ingrediente_id_pk_original);
            this.bForm = cleanBForm;
        },

        getIngIndexInWorkingValue(ingIdPk) {
            return _.findIndex(this.workingValue, (item) => {
                // ingrediente_id_pk_original: ingIdPk 
                return ((item.alcance == 'Plan' || item.encabezado_id_pk == this.recetasId) && item.ingrediente_id_pk_original == ingIdPk)
            });
        },

        isIngredientSubstituted(ingIdPk) {
            const wIndex = this.getIngIndexInWorkingValue(ingIdPk),
                objIng = (wIndex !== -1) ? this.workingValue[wIndex] : null;
            return (!(objIng === null) && objIng.metodo == 'Sustitucion');
        },
        isIngredientRemoved(ingIdPk) {
            const wIndex = this.getIngIndexInWorkingValue(ingIdPk),
                objIng = (wIndex !== -1) ? this.workingValue[wIndex] : null;
            return (!(objIng === null) && objIng.metodo == 'Omision');
        },

        makeTitle(ing) {
            try {
                if (_.isArray(ing)) {
                    throw 'Array recibido...'
                }
                return (`${ing.ingrediente}, ${parseFloat(ing.cantidad).toFixed(2)} ${ing.unidad}`).toUpperCase()
            } catch (e) {
                console.warn('error en makeTtilte(ing)', ing)
            }
        },

        ajustarIngredienteExtra(ing) {
            this.bForm = _.clone(ing)
            this.displayAdjust = true;
        },

        ajustarIngrediente(ing) {
            this._prepareIngWorkingIngAndBForm(ing)
            this.displayAdjust = true;
        },

        addEntry() {
            console.log('addEntry')
            this.bForm.encabezado_id_pk = _.clone(this.recetasId)
            this.bForm.metodo = 'Adicion'
            this.bForm.alcance = 'Receta'
            this.displayAdjust = true;
        },

        async reviewAsides() {
            if (!this.asides.ingredientes.length) {
                const response = await axios.get('ui/gruposeingredientes');
                if (response.status) {
                    this.asides.gruposnutricionales = response.data.gruposnutricionales
                    this.asides.ingredientes = response.data.ingredientes
                } else {
                    throw response.msg;
                }
            }
        },

        async getRecetaElements() {

            const response = await axios.get(this.requesURI + this.recetasId + '/' + this.planesId);

            if (!_.isObjectLike(response))
                throw 'Error de conexión';

            if (!response.status)
                throw response.msg;

            // MAP
            _.map(this.fetched, (data, itemLabel) => {
                this.fetched[itemLabel] = _.clone(response.data[itemLabel]);
            })

        },

        async reviewReceta(recetasId) {
            this.isLoading = true;
            try {
                // do something
                this.recetasId = recetasId;
                this.display = true;
                this.workingValue = _.cloneDeep(this.value)

                // consultas API
                await this.reviewAsides();
                await this.getRecetaElements();

                // finaliza la carga
                this.isLoading = false;
            } catch (e) {
                console.error(e)
                this.display = false;
            }
        }

    }

}
</script>